const notificationTypeList = [
  { key: "all", label: "All types" },
  { key: "assets", label: "Assets" },
  { key: "collection", label: "Collection" },
  { key: "waiting-room", label: "Waiting room" },
  { key: "bynder-express", label: "Bynder express" },
  { key: "workflow", label: "Workflow" },
  { key: "other", label: "Other" }
];
const units = [
  ["year", 1e3 * 60 * 60 * 24 * 365],
  ["month", 1e3 * 60 * 60 * 24 * 30],
  ["day", 1e3 * 60 * 60 * 24],
  ["hour", 1e3 * 60 * 60],
  ["minute", 1e3 * 60],
  ["second", 1e3]
];
function getSortedNotifications(courierMessages = [], customMessages = []) {
  const courier = courierMessages.map((msg) => {
    return {
      id: msg.messageId,
      title: msg.title ?? "",
      created: getSafeIsoDate(msg.created),
      type: resolveType(msg.preview),
      opened: msg.opened || null,
      archived: msg.archived || null,
      read: msg.read || null,
      isLegacy: false,
      event: resolveEvent(msg.preview)
    };
  });
  const custom = customMessages.map((msg) => {
    const createdIso = getSafeIsoDate(msg.created);
    return {
      id: msg.id,
      title: msg.content,
      created: createdIso,
      type: resolveType(msg.label),
      opened: msg.is_seen ? createdIso : null,
      archived: null,
      read: msg.is_read ? createdIso : null,
      isLegacy: true,
      event: msg.event
    };
  });
  return [...courier, ...custom].sort(
    (a, b) => new Date(b.created).getTime() - new Date(a.created).getTime()
  );
}
function getMissingNotificationTypes(notifications) {
  const allTypes = notificationTypeList.map((type) => type.label);
  const allUserTypes = notifications.map((notification) => notification.type);
  const missingTypes = allTypes.filter((type) => !allUserTypes.includes(type));
  return missingTypes.filter((type) => type !== "All types");
}
function resolveType(preview) {
  if (!preview) {
    return "Other";
  }
  const match = notificationTypeList.find((item) => new RegExp(item.label).test(preview));
  return (match == null ? void 0 : match.label) ?? "Other";
}
function resolveEvent(preview) {
  const type = resolveType(preview);
  const match = notificationTypeList.find((item) => item.label === type);
  return `${(match == null ? void 0 : match.key) ?? "other"}.courier.inbox`;
}
function getSafeIsoDate(date) {
  try {
    return new Date(date).toISOString();
  } catch {
    return (/* @__PURE__ */ new Date("2025-01-01T00:00:00Z")).toISOString();
  }
}
function hoursAgo(date, locale = "en") {
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: "always" });
  const createdTime = new Date(date);
  if (isNaN(createdTime.getTime())) {
    console.warn("Invalid date:", date);
    return "";
  }
  const diffMs = Date.now() - createdTime.getTime();
  for (const [unit, msPerUnit] of units) {
    const raw = diffMs / msPerUnit;
    const delta = unit === "year" || unit === "month" ? Math.round(raw) : Math.floor(raw);
    if (Math.abs(delta) >= 1) {
      return rtf.format(-delta, unit);
    }
  }
  return rtf.format(0, "second");
}
function getThirtyDaysAgoFromNow() {
  return new Date(Date.now() - 30 * 24 * 60 * 60 * 1e3);
}
export {
  getMissingNotificationTypes,
  getSafeIsoDate,
  getSortedNotifications,
  getThirtyDaysAgoFromNow,
  hoursAgo,
  notificationTypeList
};
//# sourceMappingURL=utils.js.map
